import isElectron from 'is-electron';
import { isDesktop } from './isDesktop';
import { getItem } from './storage';
import { getFeatureFlag } from '../featureFlags/client';

const isDesktopApp = isElectron();

export function shouldUseCoreApi(): boolean {
  if (isDesktopApp) {
    return false;
  }

  const overrideUseCoreApiFlag = getItem('useCoreApi') as boolean | undefined | null;
  if (typeof overrideUseCoreApiFlag === 'boolean') {
    return overrideUseCoreApiFlag;
  }

  return process.env.REACT_APP_SHOULD_USE_CORE_API === 'true';
}

export const shouldUseMapAccuracy = process.env.REACT_APP_FEATURE_FLAG_MAPS_ACCURACY === 'true';

/** Desktop app + `multi-org` flag must both be enabled. Synchronous: returns false if provider not yet READY. */
export function isMultiOrgFeatureEnabled(): boolean {
  return isDesktop() && getFeatureFlag('multi-org', false);
}

export function isLwtSenderFeaturesEnabled() {
  return process.env.REACT_APP_FEATURE_FLAGS_LWT_SENDER_ALARM === 'true';
}
